var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComparisonTypePlatformsBreakdown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 40,
    viewBox: "0 0 52 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 10H4C2.89543 10 2 10.8954 2 12V15C2 16.1046 2.89543 17 4 17H48C49.1046 17 50 16.1046 50 15V12C50 10.8954 49.1046 10 48 10Z",
    fill: "#8080FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23H4C2.89543 23 2 23.8954 2 25V28C2 29.1046 2.89543 30 4 30H48C49.1046 30 50 29.1046 50 28V25C50 23.8954 49.1046 23 48 23Z",
    fill: "#8080FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13H5C4.44772 13 4 13.4477 4 14V15C4 15.5523 4.44772 16 5 16H9C9.55228 16 10 15.5523 10 15V14C10 13.4477 9.55228 13 9 13Z",
    fill: "#FF6833"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13H14C13.4477 13 13 13.4477 13 14V15C13 15.5523 13.4477 16 14 16H18C18.5523 16 19 15.5523 19 15V14C19 13.4477 18.5523 13 18 13Z",
    fill: "#FF6833"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27 13H23C22.4477 13 22 13.4477 22 14V15C22 15.5523 22.4477 16 23 16H27C27.5523 16 28 15.5523 28 15V14C28 13.4477 27.5523 13 27 13Z",
    fill: "#FF6833"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 26H5C4.44772 26 4 26.4477 4 27V28C4 28.5523 4.44772 29 5 29H9C9.55228 29 10 28.5523 10 28V27C10 26.4477 9.55228 26 9 26Z",
    fill: "#FF6833"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26H14C13.4477 26 13 26.4477 13 27V28C13 28.5523 13.4477 29 14 29H18C18.5523 29 19 28.5523 19 28V27C19 26.4477 18.5523 26 18 26Z",
    fill: "#FF6833"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparisonTypePlatformsBreakdown);
export default __webpack_public_path__ + "static/media/comparison-type-platforms-breakdown.306e4f8d52eaf6d55814cf26b378e9f5.svg";
export { ForwardRef as ReactComponent };